var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLifesaverGreybg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Help_Documentation",
    "data-name": "Help Documentation",
    transform: "translate(-444 -162.549)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14190",
    "data-name": "Rectangle 14190",
    width: 52,
    height: 52,
    transform: "translate(444 162.549)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons8-web_help",
    transform: "translate(447.902 172.401)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30595",
    "data-name": "Path 30595",
    d: "M22.1,4A13.1,13.1,0,1,0,35.2,17.1,13.114,13.114,0,0,0,22.1,4Zm0,18.829A5.731,5.731,0,1,1,27.829,17.1,5.737,5.737,0,0,1,22.1,22.829Zm10.978-9.005H28.689a7.4,7.4,0,0,0-3.316-3.316V6.12A11.5,11.5,0,0,1,33.077,13.824ZM18.824,6.12v4.388a7.4,7.4,0,0,0-3.316,3.316H11.12A11.5,11.5,0,0,1,18.824,6.12Zm-7.7,14.253h4.388a7.4,7.4,0,0,0,3.316,3.316v4.388A11.5,11.5,0,0,1,11.12,20.373Zm14.253,7.7V23.689a7.4,7.4,0,0,0,3.316-3.316h4.388A11.5,11.5,0,0,1,25.373,28.077Z",
    fill: "#533ffb"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifesaverGreybg);
export default __webpack_public_path__ + "static/media/lifesaver-greybg.fbc6dc8f25ca5d0768ef479247c67239.svg";
export { ForwardRef as ReactComponent };